import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { TicketTypeFilters, TicketTypeSlice } from "./ticketTypesTypes.ts";

const initialState: TicketTypeSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const ticketTypesSlice = createSlice({
  name: "ticketTypes",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<TicketTypeSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<TicketTypeSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof TicketTypeFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<TicketTypeSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  ticketTypesSlice.actions;

export const selectPage = (state: RootState) => state.ticketTypes.page;
export const selectRowsPerPage = (state: RootState) =>
  state.ticketTypes.rowsPerPage;
export const selectFilter = (state: RootState) => state.ticketTypes.filter;
export const selectSort = (state: RootState) => state.ticketTypes.sort;

export default ticketTypesSlice.reducer;
